import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WorklogService } from 'src/app/services/worklog.service';
import { HelperService } from 'src/app/services/helper.service';
import { environment } from 'src/environments/environment';

export interface ChartDeactivationData {
  chartId: string;
  chartTypeId: string;
  customerCode: string;
  residentName: string;
  description: string;
}

export type ChartDeactivationResult = 'deactivate-in-ecase' | 'deactivate-for-me' | 'cancelled' | 'deactivated';

@Component({
  selector: 'app-worklog-chart-deactivation-dialog',
  templateUrl: './worklog-chart-deactivation-dialog.component.html',
  styleUrls: ['./worklog-chart-deactivation-dialog.component.scss']
})
export class WorklogChartDeactivationDialogComponent {
  isDeactivating = false;
  deactivationSuccess = false;
  ecaseChartUrl: string;

  constructor(
    public dialogRef: MatDialogRef<WorklogChartDeactivationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChartDeactivationData,
    private worklogService: WorklogService,
    private helperService: HelperService
  ) {
    // Prevent closing during deactivation
    this.dialogRef.disableClose = true;

    // Build eCase chart URL based on current environment
    const currentEnv = this.worklogService.getEnvironment();
    const ecaseBaseUrl = currentEnv === 'uat' ? environment.ecase.uat : environment.ecase.prod;
    this.ecaseChartUrl = `${ecaseBaseUrl}main.php?action=charts&accessmodule=charting&cid=${data.chartTypeId}&customerCode=${data.customerCode}`;
  }

  onDeactivateInEcase(): void {
    // Open eCase in a new window
    window.open(this.ecaseChartUrl, '_blank');
    this.dialogRef.close('deactivate-in-ecase');
  }

  onDeactivateForMe(): void {
    this.isDeactivating = true;

    this.worklogService.deactivateChart(this.data.chartId, this.data.customerCode, this.data.chartTypeId).subscribe({
      next: () => {
        this.deactivationSuccess = true;
        this.isDeactivating = false;
        // Show success message for 1.5 seconds, then close and proceed
        setTimeout(() => {
          this.dialogRef.close('deactivated');
        }, 1500);
      },
      error: (error) => {
        this.isDeactivating = false;
        this.helperService.openSnackBar('Failed to deactivate chart', 'Close');
        console.error('Chart deactivation failed:', error);
        // Don't close dialog on error, let user retry or cancel
      }
    });
  }

  onCancel(): void {
    if (!this.isDeactivating) {
      this.dialogRef.close('cancelled');
    }
  }
}
